import {PAGES} from "../../../../core/consts";
import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {CompetitionHighlightsPageRouteConfig} from "./models/competition-highlights-page.route.config";

export class CompetitionHighlightsPageConfig extends BaseConfig {
  static injectables = [CompetitionHighlightsPageRouteConfig];

  constructor(route: CompetitionHighlightsPageRouteConfig) {
    super(PAGES.COMPETITION.highlights, route);
  }
}
